import { AlertTriangle } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "../ui/dialog";

interface WatermarkWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
  onUpgrade: () => void;
}

/**
 * Modal component that warns free users about the watermark on their exports
 * and offers an option to upgrade to remove it.
 */
export function WatermarkWarningModal({
  isOpen,
  onClose,
  onContinue,
  onUpgrade,
}: WatermarkWarningModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader className="text-center sm:text-center">
          {/* Warning Icon */}
          <div className="mx-auto w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center mb-4">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>

          <DialogTitle className="text-xl font-bold text-gray-900">
            Your video will have a watermark
          </DialogTitle>

          <DialogDescription className="text-gray-600">
            Free accounts include a small "made with reel.cat" watermark in the
            bottom-right corner. Upgrade to export without watermarks and unlock
            more features!
          </DialogDescription>
        </DialogHeader>

        {/* Buttons */}
        <div className="flex flex-col gap-3 mt-2">
          {/* Primary CTA - Upgrade */}
          <button
            onClick={onUpgrade}
            className="w-full px-4 py-3 text-sm font-medium text-white bg-gradient-to-r from-orange-500 to-orange-600 rounded-md hover:from-orange-600 hover:to-orange-700 transition-all shadow-sm hover:shadow-md flex items-center justify-center gap-2"
          >
            Upgrade to Remove Watermark
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>

          {/* Secondary CTA - Continue */}
          <button
            onClick={onContinue}
            className="w-full px-4 py-3 text-sm font-medium text-gray-700 bg-transparent border border-gray-300 rounded-md hover:bg-gray-50 transition-all"
          >
            Continue with Watermark
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
